import {Promotion} from '../../types/singleModelInterface'

/**
 * Tells whether a promotion is shown as an accordion the user can open: it
 * needs the legal notes (`tooltip_text`) and no CTA URL, otherwise it is shown
 * as a plain item.
 *
 * @param promotion The promotion to check
 * @returns `true` if the promotion can be opened
 */
export function isExpandablePromotion(
    promotion: Pick<Promotion, 'tooltip_text' | 'cta_url'>
): boolean {
    return Boolean(promotion.tooltip_text?.length) && !promotion.cta_url
}
